/**
 * utc-date.pipe.ts
 * Copyright © 2016-2018, My Coverage Plan, Inc.
 * All rights reserved.
 */

/**
 * @author Taylor DH Smith <tdsmith@safetyweb.org>
 */

import { Pipe, PipeTransform } from "@angular/core";
import * as moment from "moment";

const DEFAULT_FORMAT : string = `MMM D, YYYY`;

const SINCE_SPECIAL_FORMAT : string = 'SINCE'

/**
 * {@link UtcDatePipe} transforms Unix timestamps into a formatted string of
 * the corresponding date in UTC. This is to overcome Angular 2's DatePipe's
 * omission of a timezone parameter, since we want our dates all in UTC but
 * by default they will convert them to local timezone, which is a day earlier.
 */
@Pipe({name: "utcDate"})
export class UtcDatePipe implements PipeTransform {

  /**
   * Transform a Date object into a string representation of that Date in UTC.
   * @param  {number|Date} value
   * @param  {string} format
   * @return {string}
   */
  public transform (value : number | Date, format : string = DEFAULT_FORMAT)
    : string
  {
    if (format === SINCE_SPECIAL_FORMAT) {
      return moment.utc(value).fromNow();
    }
    return moment.utc(value).format(format);
  }
}



// WEBPACK FOOTER //
// ./~/angular-router-loader/src!./app/support/pipes/utc-date.pipe.ts